// DS: i7.27
import React from 'react';
import IconWrap from '../../IconWrap';
const EditorClearFormat = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M14.034 6.48v3.591l-1.916-1.902V6.48h-1.701L8.423 4.5h9.639c.55 0 .997.443.997.99v1.98c0 .547-.447.99-.997.99a.994.994 0 01-.997-.99v-.99h-3.031zM14.034 15.427l3.82 3.792a.969.969 0 001.364 0 .952.952 0 000-1.354L6.146 4.889a.97.97 0 00-1.364 0 .952.952 0 000 1.354l7.336 7.282v4.836c0 .526.429.952.958.952.529 0 .958-.426.958-.952v-2.933z"
    })));
};
EditorClearFormat.displayName = 'EditorClearFormat';
export default EditorClearFormat;

//# sourceMappingURL=EditorClearFormat.js.map